import { GraphBarDataType } from '@src/Application/Types/ComponentTypes'

export type BarSection = Record<string, string | number>

export const mapData = (data: GraphBarDataType[]): BarSection[] =>
    data.map((row) => {
        const section: BarSection = {
            name: row.name,
        }

        row.values.split(';').forEach((value, i) => {
            section[`bar${i}`] = value
        })

        return section
    })
